import { useCallback } from 'react';

const useCallbackRef = <T extends HTMLElement>(
  callback: (node: T) => void,
): ((node: T | null) => void) =>
  useCallback((node: T | null) => {
    if (node) {
      callback(node);
    }
    // eslint rule ignored, as callback is the exact opposite of an exhaustive
    // dependency, in this case
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

export default useCallbackRef;
